
import BaseActionButton from '@/components/common/BaseActionButton.vue'
import DeliveryConfirmDrawer from '@/components/order/DeliveryConfirmDrawer.vue'

export default {
  name: 'CourierMobileOrders',
  components: { BaseActionButton, DeliveryConfirmDrawer },
  data () {
    return {
      orders: [],
      pool: [],
      loading: true,
      activeTab: 'all',
      filterStatus: 'all',
      courierStatus: 'offline',
      view: 'mine',
      claiming: null,
      showDeliveryDrawer: false,
      deliveryOrder: null,
      _refreshTimer: null
    }
  },
  created () {
    // 从 route query 恢复视图与筛选状态
    const q = this.$route.query
    if (q.view && (q.view === 'pool' || q.view === 'mine')) {
      this.view = q.view
    }
    if (q.status) {
      this.filterStatus = q.status
      this.activeTab = q.status
    }
    if (this.view === 'pool') {
      this.fetchPool()
    } else {
      this.fetchOrders()
    }
    this.fetchCourierStatus()
  },
  mounted () {
    this._startPolling()
  },
  beforeDestroy () {
    this._stopPolling()
  },
  methods: {
    switchView (v) {
      this.view = v
      // 同步到 route query，保证刷新/返回保留
      const query = { ...this.$route.query, view: v }
      if (v === 'mine') {
        query.status = this.filterStatus
      } else {
        delete query.status
      }
      this.$router.replace({ query }).catch(() => {})
      if (v === 'pool') this.fetchPool(); else this.fetchOrders()
    },
    // 操作后根据新状态切换到对应 tab
    followStatus (newStatus) {
      if (newStatus && newStatus !== this.filterStatus) {
        this.filterStatus = newStatus
        this.activeTab = newStatus
        const query = { ...this.$route.query, view: this.view, status: newStatus }
        this.$router.replace({ query }).catch(() => {})
      }
    },
    // === 自动刷新（30s 轮询，页面不可见时跳过） ===
    _startPolling () {
      this._stopPolling()
      this._refreshTimer = setInterval(() => {
        if (!document.hidden) {
          if (this.view === 'pool') this.fetchPool()
          else this.fetchOrders()
        }
      }, 30000)
    },
    _stopPolling () {
      if (this._refreshTimer) {
        clearInterval(this._refreshTimer)
        this._refreshTimer = null
      }
    },
    async fetchPool () {
      this.loading = true
      try {
        const res = await this.axios.get('/mobile-delivery/pool')
        this.pool = (res.data.data || []).map(o => ({ ...o, assigned_at: o.assigned_at || o.created_at }))
      } catch (e) { console.error('配送池查询失败', e) } finally { this.loading = false }
    },
    async claimPool (order) {
      if (this.claiming) return; this.claiming = order.id
      try {
        await this.axios.post('/mobile-delivery/tasks/' + order.id + '/claim')
        this.$q.notify({ type: 'positive', message: '领取成功' })
        // 领取后切换到"我的配送-待配送"，直接看到刚领取的订单
        this.view = 'mine'
        this.followStatus('inspected')
        this.fetchOrders()
      } catch (e) { this.$q.notify({ type: 'negative', message: e.response && e.response.status === 409 ? '任务已被领取' : '领取失败' }) }
      finally { this.claiming = null }
    },
    async releaseMine (order) {
      try {
        await this.axios.post('/mobile-delivery/tasks/' + order.id + '/release')
        this.$q.notify({ type: 'positive', message: '已放回配送池' }); this.fetchOrders()
      } catch (e) { this.$q.notify({ type: 'negative', message: (e.response && e.response.data && e.response.data.message) || '操作失败' }) }
    },
    async fetchOrders () {
      this.loading = true
      try {
        // 走共享 /api/mobile-delivery/mine（operator/courier 复用，金额隔离）
        const res = await this.axios.get('/mobile-delivery/mine')
        const all = (res.data.data || []).map(o => ({ ...o, assigned_at: o.assigned_at || o.created_at }))
        // 客户端按状态筛选（共享接口返回 inspected/delivering/delivered/confirmed）
        this.orders = this.filterStatus === 'all' ? all : all.filter(o => o.status === this.filterStatus)
      } catch (err) {
        console.error('获取订单失败:', err)
      } finally {
        this.loading = false
      }
    },
    async fetchCourierStatus () {
      try {
        const res = await this.axios.get('/courier-mobile/status')
        if (res.data.code === 200) {
          this.courierStatus = res.data.data.status || 'offline'
        }
      } catch (err) {
        console.error('获取状态失败:', err)
      }
    },
    async toggleStatus () {
      const newStatus = this.courierStatus === 'online' ? 'offline' : 'online'
      try {
        const res = await this.axios.put('/courier-mobile/status', { status: newStatus })
        if (res.data.code === 200) {
          this.courierStatus = newStatus
        }
      } catch (err) {
        this.$q.notify({ type: 'negative', message: '状态更新失败' })
      }
    },
    onTabChange (index, name) {
      this.filterStatus = name
      this.activeTab = name
      // 同步到 route query
      const query = { ...this.$route.query, view: this.view, status: name }
      this.$router.replace({ query }).catch(() => {})
      this.fetchOrders()
    },
    viewDetail (order) {
      this.$router.push(`/courier/orders/${order.id}`)
    },
    async startDelivery (order) {
      try {
        const res = await this.axios.post(`/mobile-delivery/orders/${order.id}/start`)
        if (res.data.code === 200) {
          this.$q.notify({ type: 'positive', message: '已开始配送' })
          this.followStatus('delivering')
          this.fetchOrders()
        }
      } catch (err) {
        this.$q.notify({ type: 'negative', message: err.response?.data?.message || '操作失败' })
      }
    },
    async markDelivered (order) {
      // 打开统一送达确认抽屉(照片+备注+确认,禁止列表直发绕过确认流程)
      this.deliveryOrder = order
      this.showDeliveryDrawer = true
    },
    // 送达成功:跟进状态+刷新(通知与关抽屉由 DeliveryConfirmDrawer 自理)
    onDeliverySuccess () {
      this.deliveryOrder = null
      this.followStatus('delivered')
      this.fetchOrders()
    },
    formatTime (timeStr) {
      if (!timeStr) return '-'
      const date = new Date(timeStr)
      return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }
  }
}
